import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import FormModel from '../../../../models/form.model';
import {Store} from '@ngrx/store';
import VideoState from '../../../shared/stores/root-store/video.state';
import {UpdateForm} from '../../../shared/stores/root-store/actions/video.action';
import {Subject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'eocm-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    @Input() form: FormModel;
    formFieldsGroup: UntypedFormGroup;
    isValidationErrorsDisplayed = false;
    formShownChange$ = new Subject<boolean>();

    constructor(
        private formBuilder: UntypedFormBuilder,
        private store: Store<{ video: VideoState }>
    ) { }

    ngOnInit() {
        this.formFieldsGroup = this.formBuilder.group({
        });

        this.formShownChange$.pipe(
            distinctUntilChanged()
        ).subscribe((formShownChange) => {
            this.store.dispatch(UpdateForm({
                form: {
                    ...this.form,
                    shown: formShownChange
                }
            }));
        })
    }

    displayFormErrors(event): void {
        this.isValidationErrorsDisplayed = event;
    }
}
